import request from './request'

//权限模块序列
export const route_model_list_request = () => {
    return request({
        method:'GET',
        url:'route_model/list'
    })
}

//权限分组序列
export const route_team_list_request = p => {
    return request({
        method:'GET',
        url:'route_team/list',
        params: p
    })
}

//权限序列
export const route_list_request = p => {
    return request({
        method:'GET',
        url:'route/list',
        params: p
    })
}

//企业序列
export const enterprise_list_request = () => {
    return request({
        method:'GET',
        url:'enterprise/list'
    })
}

//部门序列
export const department_list_request = p => {
    return request({
        method:'GET',
        url:'department/list',
        params: p
    })
}

//职位序列
export const position_list_request = p => {
    return request({
        method:'GET',
        url:'position/list',
        params: p
    })
}

//用户序列
export const staff_list_request = p => {
    return request({
        method:'GET',
        url:'staff/list',
        params: p
    })
}

//仓库序列
export const storeroom_list_request = p => {
    return request({
        method:'GET',
        url:'storeroom/list',
        params: p
    })
}

//库位序列
export const location_list_request = p => {
    return request({
        method:'GET',
        url:'location/list',
        params: p
    })
}

//入库单序列
export const entry_bill_list_request = p => {
    return request({
        method:'GET',
        url:'entry_bill/list',
        params: p
    })
}

//客户序列
export const client_list_request = p => {
    return request({
        method:'GET',
        url:'client/list',
        params: p
    })
}

//客户存储率序列
export const client_stock_rate_list_request = p => {
    return request({
        method:'GET',
        url:'client_stock_rate/list',
        params: p
    })
}

//仓库产品序列
export const product_list_request = p => {
    return request({
        method:'GET',
        url:'product/list',
        params: p
    })
}

//出库单序列
export const detry_bill_list_request = p => {
    return request({
        method:'GET',
        url:'detry_bill/list',
        params: p
    })
}

//移库单序列
export const mvtry_bill_list_request = p => {
    return request({
        method:'GET',
        url:'mvtry_bill/list',
        params: p
    })
}

//银行卡序列
export const bank_card_list_request = () => {
    return request({
        method:'GET',
        url:'bank_card/list'
    })
}

//采购管理序列
export const purchase_list_request = () => {
    return request({
        method:'GET',
        url:'purchase/list'
    })
}

//招待管理序列
export const entertain_list_request = () => {
    return request({
        method:'GET',
        url:'entertain/list'
    })
}

//差旅管理序列
export const travel_list_request = () => {
    return request({
        method:'GET',
        url:'travel/list'
    })
}

//备用金序列
export const petty_list_request = () => {
    return request({
        method:'GET',
        url:'petty/list'
    })
}

//用户头像序列
export const avatar_list_request = () => {
    return request({
        method:'GET',
        url:'avatar/list'
    })
}

//租用场地序列
export const site_list_request = () => {
    return request({
        method:'GET',
        url:'rent_site/list'
    })
}

//固定费率序列
export const fixed_rate_list_request = p => {
    return request({
        method:'GET',
        url:'rent_fixed_rate/list',
        params: p
    })
}

//智汇物流业务付款序列
export const business_payment_list_request = () => {
    return request({
        method:'GET',
        url:'business_payment/list'
    })
}


//招待客户序列
export const entertain_client_list_request = () => {
    return request({
        method:'GET',
        url:'entertain_client/list'
    })
}

//差旅目的地序列
export const travel_address_list_request = () => {
    return request({
        method:'GET',
        url:'travel_address/list'
    })
}

//报销类目列表
export const reimbursement_category_list_request = () => {
    return request({
        method:'GET',
        url:'reimbursement_category/list'
    })
}

//休假类型序列
export const vacation_category_list_request = () => {
    return request({
        method:'GET',
        url:'vacation_category/list'
    })
}

//订舱模板序列
export const cop_template_list_request = () => {
    return request({
        method:'GET',
        url:'cop_template/list'
    })
}

// 包装标识序列
export const cop_package_type_list_request = () => {
    return request({
        method:'GET',
        url:'cop_template/package_type_list'
    })
}

// 公用考核标题序列
export const kpi_common_title_list_request = () => {
    return request({
        method:'GET',
        url:'common_title/list'
    })
}

// 印章使用申请类型序列
export const currency_category_list_request = () => {
    return request({
        method:'GET',
        url:'currency_category/list'
    })
}

// 装卸平台序列
export const terrace_list_request = () => {
    return request({
        method:'GET',
        url:'terrace/list'
    })
}

// 车辆业务类型序列
export const car_business_type_list_request = () => {
    return request({
        method:'GET',
        url:'car_business_type/list'
    })
}

// 车辆大小类型序列
export const car_size_type_list_request = () => {
    return request({
        method:'GET',
        url:'car_size_type/list'
    })
}